import styles from './ActionBar.css'
import {reduxForm, Field, formValueSelector, isDirty} from 'redux-form'
import {connect} from 'react-redux'
import DropdownOutlet from 'components/Fields/ReduxForm/DropdownOutlet'
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect'
import SearchBar from 'components/Fields/ReduxForm/SearchBar'
import {DropdownButton, MenuItem} from 'react-bootstrap'
import * as actIngredientLibrary from 'actions/ingredients/library'
import {askConfirmAction} from 'actions/confirm-action'

class ActionBar extends React.Component {
  render () {
    let {outlets, inventories, categories, summary, onClickImport, onClickExport} = this.props
    return (<div className={styles.wrapper}>
      <div className='col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding'>
        <div className='col-md-7 col-sm-7 col-xs-12 no-padding left-filter'>
          <ul className={styles['ul-filter']}>
            <li className={`${styles['li-filter']} li-dropdown-outlet visible-md visible-lg`}>
              <Field
                name='outletIds'
                component={DropdownOutlet}
                outlets={outlets}
                onChangeOutletIds={this._onChangeOutletIds}
              />
            </li>
            <li className={`${styles['li-filter']} li-dropdown-category`}>
              <Field
                name='categoryId'
                component={DropdownSelect}
                options={categories}
                defaultOption={{id: 0, name: 'All Categories'}}
                className='dropdown-select-categories'
                id='filterSelectCategory'
                onChange={this._onChangeFilterCategory}
              />
            </li>
            <li className={`${styles['li-filter']} li-dropdown-type-inventory`}>
              <Field
                name='typeInventoryId'
                component={DropdownSelect}
                options={inventories}
                className='dropdown-select-inventories'
                id='filterSelectInventory'
                onChange={this._onChangeFilterInventory}
              />
            </li>
            <li className={`${styles['li-filter']} li-searching`}>
              <Field
                name='search'
                component={SearchBar}
                placeholder='Search'
                onChange={this._onChangeFilterKeyword}
              />
            </li>
          </ul>
        </div>
        <div className='col-md-5 col-sm-5 col-xs-12 no-padding right-filter'>
          <ul className={`${styles['ul-filter']} ${styles['filter-right']}`}>
            <li className={`${styles['li-filter-right']} li-total-item visible-md visible-lg`}>
              <button className='btn btn-primary' onClick={this._onClickCreateItem}>Create Ingredient</button>
            </li>
            <li className={`${styles['li-filter-right']} li-total-item`}>
              <DropdownButton title='Import / Export' bsStyle='primary'>
                <MenuItem onSelect={onClickImport}>Import Ingredients</MenuItem>
                <MenuItem divider />
                <MenuItem onSelect={onClickExport}>Export Ingredients</MenuItem>
              </DropdownButton>
            </li>
            <li className={`${styles['li-filter-right']} li-total-item`}>
              <a className={`${styles['btn-total']} btn btn-default`}>Total : {summary.total_count}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>)
  }

  _onClickCreateItem = () => {
    let {uncategorized, isDirtyLibrary} = this.props
    if (isDirtyLibrary) {
      this.props.dispatch(askConfirmAction(actIngredientLibrary.onClickCreateLibrary(uncategorized)))
    } else {
      this.props.dispatch(actIngredientLibrary.onClickCreateLibrary(uncategorized))
    }
  }

  _onChangeFilterCategory = (event, categoryId) => {
    let {typeInventoryId, search, outletIds} = this.props.filterForm
    this.props.dispatch(actIngredientLibrary.setFilterLibrary(categoryId, typeInventoryId, search, outletIds))
  }

  _onChangeFilterInventory = (event, typeInventoryId) => {
    let {categoryId, search, outletIds} = this.props.filterForm
    this.props.dispatch(actIngredientLibrary.setFilterLibrary(categoryId, typeInventoryId, search, outletIds))
  }

  _onChangeFilterKeyword = (event, search) => {
    let {categoryId, typeInventoryId, outletIds} = this.props.filterForm
    this.props.dispatch(actIngredientLibrary.setFilterLibrary(categoryId, typeInventoryId, search, outletIds))
  }

  _onChangeOutletIds = (outletIds) => {
    const {isDirtyLibrary} = this.props
    let {categoryId, typeInventoryId} = this.props.filterForm
    if (isDirtyLibrary) {
      this.props.dispatch(askConfirmAction(actIngredientLibrary.onChangeOutletIds(outletIds, categoryId, typeInventoryId)))
    } else {
      this.props.dispatch(actIngredientLibrary.onChangeOutletIds(outletIds))
    }
  }
}

const mapForm = {
  form: 'search'
}

const selector = formValueSelector('search')

function mapStateToProps (state) {
  let {libraries, summary, categories, itemDetail, deletedLibrary, showDeleteLibraryModal, currentPage, totalPage, inventories, currentInventoryId, currentCategoryId, outlets, uncategorized} = state.ingredients.library
  const { categoryId, typeInventoryId, search, outletIds } = selector(state, 'categoryId', 'typeInventoryId', 'search', 'outletIds')
  const isDirtyLibrary = isDirty('library')(state)
  return {
    uncategorized,
    categories,
    outlets,
    libraries,
    itemDetail,
    deletedLibrary,
    showDeleteLibraryModal,
    currentPage,
    totalPage,
    inventories,
    currentInventoryId,
    currentCategoryId,
    summary,
    isDirtyLibrary,
    filterForm: {categoryId, typeInventoryId, search, outletIds}
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch: dispatch}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(mapForm)(ActionBar))



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Library/ActionBar/ActionBar.js